import React, { FC, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Course } from 'src/apiClassic/dashboard/schema';
import { Icon } from 'src/components';
import * as S from './styles';

const msgs = defineMessages({
  titleOfficial: {
    id: 'migration_hybrid_description_courses_box_official',
    defaultMessage: 'Your Memrise Approved Courses',
  },
  titleUGC: {
    id: 'migration_hybrid_description_courses_box_ugc',
    defaultMessage: 'Your Community Courses',
  },
  movedUGC: {
    id: 'migration_ugc_description_courses_box',
    defaultMessage: 'Your courses being moved',
  },
});

type CollapsibleCardClassicProps = {
  numberOfCourses: number;
  listOfCourses: Course[];
  isOfficial: boolean;
  pureUGC?: boolean;
};

export const CollapsibleCardClassic: FC<CollapsibleCardClassicProps> = ({
  numberOfCourses,
  listOfCourses,
  isOfficial,
  pureUGC,
}) => {
  const intl = useIntl();
  const [showCollapsible, setShowCollapsible] = useState(pureUGC);

  return (
    <S.CollapsibleCard
      onClick={() => setShowCollapsible(!showCollapsible)}
      $isOfficial={isOfficial}
    >
      <S.CardButton>
        <S.Header>
          <Icon name={isOfficial ? 'memriseSmallBlack' : 'social'} />
          {intl.formatMessage(
            isOfficial ? msgs.titleOfficial : pureUGC ? msgs.movedUGC : msgs.titleUGC,
          )}{' '}
          ({numberOfCourses})
        </S.Header>
        <S.Icon $collapsed={!showCollapsible} name="down" />
      </S.CardButton>
      <S.CardDescription
        $collapsed={!showCollapsible}
        data-testid="CollapsibleCardClassic-collapsed-block"
      >
        {listOfCourses.map(course => (
          <S.CardElement key={course.name}>{course.name}</S.CardElement>
        ))}
      </S.CardDescription>
    </S.CollapsibleCard>
  );
};
